export const heroBanners = [
  {
    id: 1,
    title: '流浪地球3',
    subtitle: '中国科幻史诗续作 · 人类命运的最后抉择',
    description: '太阳急速老化，持续膨胀。100年后，太阳将膨胀到地球轨道。为了生存，人类提出"流浪地球"计划，在地球表面建造上万座行星发动机，推动地球离开太阳系，前往4.2光年外的新家园。',
    rating: 9.2,
    year: 2026,
    category: '科幻',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20with%20dramatic%20golden%20lighting%20and%20deep%20space%20atmosphere%2C%20dark%20warm%20tones%2C%20cinematic%20photography%2C%20film%20grain%20texture%2C%20professional%20movie%20poster%20aesthetic&width=1920&height=900&seq=hero-banner-1&orientation=landscape',
  },
  {
    id: 2,
    title: '封神第二部',
    subtitle: '神话史诗巨制 · 战火西岐',
    description: '殷商大军兵临西岐，姜子牙率领众神迎战。姬发在战火中成长，面对殷寿的滔天权势，他必须做出关乎天下苍生的抉择。',
    rating: 8.8,
    year: 2026,
    category: '奇幻',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20epic%20battle%20scene%20with%20dramatic%20warm%20golden%20lighting%2C%20dark%20atmospheric%20mood%2C%20cinematic%20photography%2C%20professional%20movie%20poster%20aesthetic%2C%20ancient%20warriors%20in%20motion&width=1920&height=900&seq=hero-banner-2&orientation=landscape',
  },
  {
    id: 3,
    title: '狂飙',
    subtitle: '扫黑风暴再起 · 年度现象级爆款剧',
    description: '以一线刑警安欣为代表的正义力量，与黑恶势力展开长达二十年的生死搏斗，通过群像叙事展现扫黑除恶中的黑白较量与复杂人性。',
    rating: 9.5,
    year: 2025,
    category: '悬疑',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gritty%20crime%20drama%20cinematic%20scene%20with%20dark%20moody%20lighting%2C%20urban%20night%20atmosphere%2C%20film%20noir%20style%2C%20professional%20movie%20poster%20aesthetic%2C%20deep%20shadows%20and%20warm%20highlights&width=1920&height=900&seq=hero-banner-3&orientation=landscape',
  },
];

export const categories = [
  { id: 'all', name: '全部', slug: 'all' },
  { id: 'action', name: '动作片', slug: 'action' },
  { id: 'comedy', name: '喜剧片', slug: 'comedy' },
  { id: 'romance', name: '爱情片', slug: 'romance' },
  { id: 'scifi', name: '科幻片', slug: 'scifi' },
  { id: 'suspense', name: '悬疑片', slug: 'suspense' },
  { id: 'horror', name: '恐怖片', slug: 'horror' },
  { id: 'drama', name: '剧情片', slug: 'drama' },
  { id: 'animation', name: '动画片', slug: 'animation' },
  { id: 'documentary', name: '纪录片', slug: 'documentary' },
  { id: 'tvseries', name: '电视剧', slug: 'tvseries' },
  { id: 'variety', name: '综艺', slug: 'variety' },
];

export interface MovieItem {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  category: string;
  rating: number;
  year: number;
  duration: string;
  quality: string;
  imageUrl: string;
  thumbUrl: string;
  tags: string[];
  views: string;
  updateInfo: string;
  director: string;
  actors: string[];
  region: string;
}

export const hotMovies: MovieItem[] = [
  {
    id: 101,
    title: '流浪地球3',
    subtitle: '带着地球去流浪',
    description: '太阳急速老化，持续膨胀。100年后，太阳将膨胀到地球轨道。为了生存，人类提出"流浪地球"计划，在地球表面建造上万座行星发动机，推动地球离开太阳系，前往4.2光年外的新家园。在这一漫长而悲壮的旅程中，人类面临着前所未有的挑战与抉择。',
    category: 'scifi',
    rating: 9.2,
    year: 2026,
    duration: '148分钟',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20dramatic%20golden%20lighting%2C%20space%20theme%2C%20dark%20warm%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-101&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20still%20with%20warm%20golden%20atmosphere%2C%20space%20scene%2C%20soft%20focus%20background%2C%20professional%20movie%20cinematography&width=320&height=180&seq=hot-movie-thumb-101&orientation=landscape',
    tags: ['科幻', '灾难', '国产巨制'],
    views: '2.3亿',
    updateInfo: '今日更新',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    region: '中国大陆',
  },
  {
    id: 102,
    title: '封神第二部',
    subtitle: '战火西岐',
    description: '殷商大军兵临西岐，姜子牙率领众神迎战。姬发在战火中成长，面对殷寿的滔天权势，他必须做出关乎天下苍生的抉择。神话史诗的壮丽篇章在此展开，古老传说中的英雄们将书写新的传奇。',
    category: 'action',
    rating: 8.8,
    year: 2026,
    duration: '155分钟',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20epic%20movie%20poster%20with%20dramatic%20warm%20lighting%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic%2C%20ancient%20warrior&width=600&height=900&seq=hot-movie-poster-102&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20battle%20cinematic%20still%20with%20warm%20atmosphere%2C%20mythological%20scene%2C%20professional%20movie%20cinematography%2C%20soft%20focus&width=320&height=180&seq=hot-movie-thumb-102&orientation=landscape',
    tags: ['动作', '奇幻', '神话'],
    views: '1.8亿',
    updateInfo: '热门推荐',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
    region: '中国大陆',
  },
  {
    id: 103,
    title: '热辣滚烫',
    subtitle: '你只活一次',
    description: '宅女杜乐莹在经历一系列挫折后，偶然结识了拳击教练昊坤。在拳击的世界里，她找到了人生的方向，开始了从自我放逐到自我实现的热血蜕变之路。',
    category: 'comedy',
    rating: 8.5,
    year: 2025,
    duration: '129分钟',
    quality: '1080P',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20warm%20golden%20lighting%2C%20boxing%20theme%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-103&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Boxing%20gym%20cinematic%20still%20with%20warm%20atmosphere%2C%20inspirational%20scene%2C%20professional%20movie%20cinematography%2C%20soft%20focus&width=320&height=180&seq=hot-movie-thumb-103&orientation=landscape',
    tags: ['喜剧', '励志', '运动'],
    views: '3.1亿',
    updateInfo: '口碑佳作',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    region: '中国大陆',
  },
  {
    id: 104,
    title: '消失的她',
    subtitle: '真相永远只有一个',
    description: '何非的妻子李木子在海外旅行中神秘失踪，当何非苦寻无果之时，一个陌生女人突然出现，声称自己才是他的妻子。随着调查深入，越来越多的谜团浮现，真相远比想象中更加惊心动魄。',
    category: 'suspense',
    rating: 8.9,
    year: 2025,
    duration: '121分钟',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%20with%20dark%20moody%20lighting%2C%20film%20noir%20style%2C%20warm%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-104&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinematic%20still%20with%20dark%20atmosphere%2C%20film%20noir%20scene%2C%20professional%20movie%20cinematography%2C%20moody%20lighting&width=320&height=180&seq=hot-movie-thumb-104&orientation=landscape',
    tags: ['悬疑', '犯罪', '反转'],
    views: '2.7亿',
    updateInfo: '高分悬疑',
    director: '陈思诚',
    actors: ['朱一龙', '倪妮', '文咏珊'],
    region: '中国大陆',
  },
  {
    id: 105,
    title: '你的名字',
    subtitle: '跨越时空的爱恋',
    description: '生活在乡下的三叶和东京高中生�意外灵魂互换，两人在彼此的生活中留下了深刻的印记。当他们试图寻找对方时，却发现一场命运的浩劫正悄然逼近。',
    category: 'animation',
    rating: 9.3,
    year: 2016,
    duration: '106分钟',
    quality: '1080P',
    imageUrl: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20romance%20movie%20poster%20with%20beautiful%20sky%20background%2C%20warm%20golden%20lighting%2C%20cinematic%20style%2C%20professional%20anime%20film%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-105&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Anime%20cinematic%20still%20with%20beautiful%20sky%20and%20warm%20atmosphere%2C%20romantic%20scene%2C%20professional%20anime%20cinematography%2C%20soft%20lighting&width=320&height=180&seq=hot-movie-thumb-105&orientation=landscape',
    tags: ['动画', '爱情', '奇幻'],
    views: '1.5亿',
    updateInfo: '经典回顾',
    director: '新海诚',
    actors: ['神木隆之介', '上白石萌音'],
    region: '日本',
  },
  {
    id: 106,
    title: '孤注一掷',
    subtitle: '揭露境外诈骗黑幕',
    description: '程序员潘生和模特安娜被高薪招聘所诱惑，前往海外工作。他们不知道等待自己的是一场精心策划的骗局，被困在境外诈骗工厂中。为了逃脱，他们必须与诈骗头目斗智斗勇。',
    category: 'suspense',
    rating: 8.7,
    year: 2025,
    duration: '130分钟',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20dark%20intense%20lighting%2C%20urban%20night%20theme%2C%20warm%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-106&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20cinematic%20still%20with%20dark%20urban%20atmosphere%2C%20intense%20scene%2C%20professional%20movie%20cinematography%2C%20moody%20lighting&width=320&height=180&seq=hot-movie-thumb-106&orientation=landscape',
    tags: ['犯罪', '现实题材', '惊悚'],
    views: '3.5亿',
    updateInfo: '年度爆款',
    director: '申奥',
    actors: ['张艺兴', '金晨', '王传君'],
    region: '中国大陆',
  },
  {
    id: 107,
    title: '长安三万里',
    subtitle: '诗意大唐的壮丽画卷',
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。被困孤城的大唐节度使高适，回忆起自己与李白跨越数十年的深厚情谊，以及那个群星璀璨的诗歌黄金时代。',
    category: 'animation',
    rating: 9.0,
    year: 2025,
    duration: '168分钟',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20animated%20movie%20poster%20with%20ancient%20Tang%20dynasty%20theme%2C%20warm%20golden%20lighting%2C%20poetic%20style%2C%20cinematic%20animation%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-107&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20dynasty%20animated%20cinematic%20still%20with%20warm%20atmosphere%2C%20poetic%20scene%2C%20professional%20animation%20cinematography%2C%20golden%20lighting&width=320&height=180&seq=hot-movie-thumb-107&orientation=landscape',
    tags: ['动画', '历史', '诗意'],
    views: '1.9亿',
    updateInfo: '高分动画',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫'],
    region: '中国大陆',
  },
  {
    id: 108,
    title: '奥本海默',
    subtitle: '原子弹之父的内心世界',
    description: '二战期间，物理学家罗伯特·奥本海默被任命为曼哈顿计划的负责人，负责研发原子弹。随着项目的推进，他不得不面对科学与道德之间的深刻矛盾，以及权力游戏中的身不由己。',
    category: 'drama',
    rating: 9.1,
    year: 2025,
    duration: '180分钟',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Historical%20biographical%20drama%20movie%20poster%20with%20dramatic%20warm%20lighting%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic%2C%20intense%20expression&width=600&height=900&seq=hot-movie-poster-108&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Historical%20drama%20cinematic%20still%20with%20warm%20atmosphere%2C%20intense%20scene%2C%20professional%20movie%20cinematography%2C%20dramatic%20lighting&width=320&height=180&seq=hot-movie-thumb-108&orientation=landscape',
    tags: ['传记', '历史', '剧情'],
    views: '1.2亿',
    updateInfo: '奥斯卡佳作',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '小罗伯特·唐尼'],
    region: '美国',
  },
];

export const latestMovies: MovieItem[] = [
  {
    id: 201,
    title: '第二十条',
    subtitle: '法律的温度',
    description: '人到中年的检察官韩明卷入了一桩分歧巨大的案件。面对情与法的考验，他必须在职业操守和人性关怀之间寻找平衡。',
    category: 'drama',
    rating: 8.6,
    year: 2026,
    duration: '141分钟',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%20with%20dramatic%20warm%20lighting%2C%20courtroom%20theme%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=latest-movie-poster-201&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Courtroom%20drama%20cinematic%20still%20with%20warm%20atmosphere%2C%20legal%20scene%2C%20professional%20movie%20cinematography%2C%20soft%20lighting&width=320&height=180&seq=latest-movie-thumb-201&orientation=landscape',
    tags: ['剧情', '法律', '人性'],
    views: '2.1亿',
    updateInfo: '2小时前更新',
    director: '张艺谋',
    actors: ['雷佳音', '马丽', '赵丽颖'],
    region: '中国大陆',
  },
  {
    id: 202,
    title: '飞驰人生2',
    subtitle: '热血赛车燃情回归',
    description: '曾经的赛车冠军张驰沦为驾校教练，过着平凡的生活。当老朋友的邀请让他有机会重返赛场时，他心中的赛车梦想再次被点燃。',
    category: 'comedy',
    rating: 8.4,
    year: 2026,
    duration: '130分钟',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20dynamic%20warm%20lighting%2C%20motorsport%20theme%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=latest-movie-poster-202&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Racing%20car%20cinematic%20still%20with%20warm%20atmosphere%2C%20dynamic%20action%20scene%2C%20professional%20movie%20cinematography%2C%20motion%20blur&width=320&height=180&seq=latest-movie-thumb-202&orientation=landscape',
    tags: ['喜剧', '运动', '励志'],
    views: '2.8亿',
    updateInfo: '5小时前更新',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正'],
    region: '中国大陆',
  },
  {
    id: 203,
    title: '熊出没·逆转时空',
    subtitle: '全新冒险旅程',
    description: '光头强在一次意外中获得了一台神秘的时间机器，和熊大熊二一起穿越到不同的时空，展开了一段惊险刺激又充满欢笑的冒险之旅。',
    category: 'animation',
    rating: 8.2,
    year: 2026,
    duration: '99分钟',
    quality: '1080P',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20movie%20poster%20with%20colorful%20warm%20lighting%2C%20adventure%20theme%2C%20dark%20background%2C%20fun%20cinematic%20style%2C%20professional%20animation%20poster&width=600&height=900&seq=latest-movie-poster-203&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Animated%20family%20cinematic%20still%20with%20warm%20atmosphere%2C%20adventure%20scene%2C%20professional%20animation%20cinematography%2C%20colorful%20lighting&width=320&height=180&seq=latest-movie-thumb-203&orientation=landscape',
    tags: ['动画', '冒险', '合家欢'],
    views: '1.6亿',
    updateInfo: '8小时前更新',
    director: '林永长',
    actors: ['谭笑', '张秉君'],
    region: '中国大陆',
  },
  {
    id: 204,
    title: '三大队',
    subtitle: '十二年追凶无悔',
    description: '一名刑警在追捕嫌犯过程中因意外入狱，出狱后依然以普通人身份坚持追凶。十二年如一日，只为还原真相，将罪犯绳之以法。',
    category: 'suspense',
    rating: 8.9,
    year: 2026,
    duration: '132分钟',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20movie%20poster%20with%20dark%20intense%20lighting%2C%20police%20theme%2C%20warm%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=latest-movie-poster-204&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Crime%20investigation%20cinematic%20still%20with%20dark%20atmosphere%2C%20police%20scene%2C%20professional%20movie%20cinematography%2C%20moody%20lighting&width=320&height=180&seq=latest-movie-thumb-204&orientation=landscape',
    tags: ['犯罪', '悬疑', '真实改编'],
    views: '1.9亿',
    updateInfo: '12小时前更新',
    director: '戴墨',
    actors: ['张译', '李晨', '魏晨'],
    region: '中国大陆',
  },
  {
    id: 205,
    title: '年会不能停',
    subtitle: '职场喜剧笑中带泪',
    description: '在一场啼笑皆非的职场闹剧中，钳工胡建林阴差阳错被调入集团总部，与人事经理马杰在年会上展开了一场关于梦想与现实的精彩对决。',
    category: 'comedy',
    rating: 8.3,
    year: 2025,
    duration: '117分钟',
    quality: '1080P',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20movie%20poster%20with%20warm%20bright%20lighting%2C%20office%20theme%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=latest-movie-poster-205&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Office%20comedy%20cinematic%20still%20with%20warm%20atmosphere%2C%20corporate%20party%20scene%2C%20professional%20movie%20cinematography%2C%20bright%20lighting&width=320&height=180&seq=latest-movie-thumb-205&orientation=landscape',
    tags: ['喜剧', '职场', '讽刺'],
    views: '2.5亿',
    updateInfo: '1天前更新',
    director: '董润年',
    actors: ['大鹏', '白客', '庄达菲'],
    region: '中国大陆',
  },
  {
    id: 206,
    title: '涉过愤怒的海',
    subtitle: '为女复仇的绝望之路',
    description: '花季少女身中十七刀离奇死亡，父亲老金踏上了跨国追凶之路。随着调查深入，隐藏在案件背后的人性黑暗与原生家庭的伤痛逐渐浮出水面。',
    category: 'suspense',
    rating: 8.5,
    year: 2025,
    duration: '144分钟',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20revenge%20thriller%20movie%20poster%20with%20dark%20moody%20lighting%2C%20ocean%20theme%2C%20warm%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=latest-movie-poster-206&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Dark%20ocean%20cinematic%20still%20with%20moody%20atmosphere%2C%20thriller%20scene%2C%20professional%20movie%20cinematography%2C%20storm%20lighting&width=320&height=180&seq=latest-movie-thumb-206&orientation=landscape',
    tags: ['悬疑', '犯罪', '家庭'],
    views: '1.7亿',
    updateInfo: '1天前更新',
    director: '曹保平',
    actors: ['黄渤', '周迅', '祖峰'],
    region: '中国大陆',
  },
  {
    id: 207,
    title: '铃芽之旅',
    subtitle: '关闭灾难之门',
    description: '少女岩户铃芽邂逅了正在寻找废墟之门的青年宗像草太，跟随着他踏上关闭灾难之门的旅程。在旅途中，她逐渐面对自己内心深处的伤痛与记忆。',
    category: 'animation',
    rating: 8.7,
    year: 2025,
    duration: '122分钟',
    quality: '1080P',
    imageUrl: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20adventure%20movie%20poster%20with%20beautiful%20warm%20lighting%2C%20fantasy%20door%20theme%2C%20dark%20background%2C%20cinematic%20anime%20poster%20aesthetic&width=600&height=900&seq=latest-movie-poster-207&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Anime%20fantasy%20cinematic%20still%20with%20warm%20atmosphere%2C%20adventure%20scene%2C%20professional%20anime%20cinematography%2C%20golden%20sunset%20lighting&width=320&height=180&seq=latest-movie-thumb-207&orientation=landscape',
    tags: ['动画', '奇幻', '冒险'],
    views: '1.3亿',
    updateInfo: '2天前更新',
    director: '新海诚',
    actors: ['原菜乃华', '松村北斗'],
    region: '日本',
  },
  {
    id: 208,
    title: '志愿军：存亡之战',
    subtitle: '抗美援朝战争史诗',
    description: '1950年，朝鲜战争爆发。中国人民志愿军跨过鸭绿江，在极端恶劣的条件下与装备精良的联合国军展开殊死搏斗，用血肉之躯筑起了保家卫国的钢铁长城。',
    category: 'action',
    rating: 8.8,
    year: 2026,
    duration: '150分钟',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20war%20epic%20movie%20poster%20with%20dramatic%20warm%20lighting%2C%20battlefield%20theme%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=latest-movie-poster-208&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=War%20battle%20cinematic%20still%20with%20dramatic%20atmosphere%2C%20epic%20action%20scene%2C%20professional%20movie%20cinematography%2C%20smoke%20and%20fire&width=320&height=180&seq=latest-movie-thumb-208&orientation=landscape',
    tags: ['战争', '历史', '动作'],
    views: '2.2亿',
    updateInfo: '2天前更新',
    director: '陈凯歌',
    actors: ['唐国强', '王砚辉', '刘劲'],
    region: '中国大陆',
  },
];

export const tvSeries: MovieItem[] = [
  {
    id: 301,
    title: '狂飙',
    subtitle: '扫黑除恶二十年',
    description: '以一线刑警安欣为代表的正义力量，与黑恶势力展开长达二十年的生死搏斗。通过群像叙事展现扫黑除恶中的黑白较量与复杂人性，揭示黑恶势力滋生的社会根源。',
    category: 'tvseries',
    rating: 9.5,
    year: 2025,
    duration: '39集全',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20TV%20drama%20poster%20with%20dark%20intense%20lighting%2C%20police%20theme%2C%20warm%20dark%20background%2C%20cinematic%20style%2C%20professional%20drama%20poster%20aesthetic&width=600&height=900&seq=tv-series-poster-301&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Crime%20drama%20TV%20cinematic%20still%20with%20dark%20urban%20atmosphere%2C%20intense%20scene%2C%20professional%20cinematography%2C%20moody%20lighting&width=320&height=180&seq=tv-series-thumb-301&orientation=landscape',
    tags: ['悬疑', '犯罪', '群像'],
    views: '8.6亿',
    updateInfo: '全剧完结',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    region: '中国大陆',
  },
  {
    id: 302,
    title: '庆余年第二季',
    subtitle: '权谋天下的终极对决',
    description: '范闲在经历生死考验后，以更加强大的姿态回到京都。面对更加复杂的朝堂局势和多方势力的算计，他步步为营，在权谋的漩涡中寻找属于自己的道。',
    category: 'tvseries',
    rating: 9.0,
    year: 2026,
    duration: '36集全',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20with%20warm%20golden%20lighting%2C%20ancient%20palace%20theme%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20drama%20poster%20aesthetic&width=600&height=900&seq=tv-series-poster-302&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20cinematic%20still%20with%20warm%20atmosphere%2C%20historical%20drama%20scene%2C%20professional%20cinematography%2C%20golden%20lighting&width=320&height=180&seq=tv-series-thumb-302&orientation=landscape',
    tags: ['古装', '权谋', '喜剧'],
    views: '6.2亿',
    updateInfo: '全剧完结',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    region: '中国大陆',
  },
  {
    id: 303,
    title: '繁花',
    subtitle: '上海滩的浮世绘',
    description: '九零年代初，煌煌大时代，人人争上游。阿宝凭着智慧和魄力在黄河路上从无名小卒变成风云人物。在他的成长路上，有贵人相助，也有红颜知己，更有人生起伏。',
    category: 'tvseries',
    rating: 9.3,
    year: 2025,
    duration: '30集全',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20with%20nostalgic%20warm%20lighting%2C%20Shanghai%201990s%20theme%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20drama%20poster%20aesthetic&width=600&height=900&seq=tv-series-poster-303&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Shanghai%201990s%20cinematic%20still%20with%20warm%20nostalgic%20atmosphere%2C%20period%20drama%20scene%2C%20professional%20cinematography%2C%20soft%20lighting&width=320&height=180&seq=tv-series-thumb-303&orientation=landscape',
    tags: ['年代', '商战', '爱情'],
    views: '5.8亿',
    updateInfo: '全剧完结',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣'],
    region: '中国大陆',
  },
  {
    id: 304,
    title: '长相思',
    subtitle: '上古情缘虐心绝恋',
    description: '上古时期，人神妖混居。流落大荒的皓翎王姬小夭，历经百年颠沛之苦，在清水镇落脚，化身玟小六。她的出现，搅动了表哥玱玹、青丘公子涂山璟、九头妖相柳的命运。',
    category: 'tvseries',
    rating: 8.7,
    year: 2025,
    duration: '39集全',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20ethereal%20warm%20lighting%2C%20ancient%20mythology%20theme%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20drama%20poster%20aesthetic&width=600&height=900&seq=tv-series-poster-304&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20cinematic%20still%20with%20ethereal%20atmosphere%2C%20ancient%20mythical%20scene%2C%20professional%20cinematography%2C%20soft%20dreamy%20lighting&width=320&height=180&seq=tv-series-thumb-304&orientation=landscape',
    tags: ['古装', '奇幻', '爱情'],
    views: '4.5亿',
    updateInfo: '全剧完结',
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为'],
    region: '中国大陆',
  },
];

export const features = [
  {
    icon: 'ri-speed-up-line',
    title: '秒开播放',
    description: '采用先进的P2P-CDN加速技术，点击即播，告别漫长等待。全网领先的加载速度，让观影体验快人一步。',
  },
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    description: '支持4K、HDR超高清画质，每一帧都清晰细腻。智能码率调节，根据网络环境自动匹配最佳清晰度。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    description: '全程无贴片广告，无弹窗打扰。专注于内容本身，让您沉浸在影视的精彩世界中不受干扰。',
  },
  {
    icon: 'ri-global-line',
    title: '海量片库',
    description: '收录超过10万部电影电视剧，涵盖动作、喜剧、科幻、悬疑等多种类型。每日更新最新资源，永不错过精彩。',
  },
];

export const stats = [
  { value: '10万+', label: '影视资源' },
  { value: '5000万+', label: '活跃用户' },
  { value: '99.9%', label: '播放成功率' },
  { value: '24h', label: '全天候更新' },
];